// extracted by mini-css-extract-plugin
export var body = "index-module--body--3iuAY";
export var wrapper = "index-module--wrapper--M3x8D";
export var navigation = "index-module--navigation--1WjG3";
export var content = "index-module--content--2tOJB";
export var title = "index-module--title--3RmM1";